import { useGoalDetailPortfoliosQuery } from "web_myplann/Api/Goals/useGoalDetailPortfoliosQuery";
import { ALLOCATION_MAX, ALLOCATION_MIN } from "web_myplann/Goals/constants";
import type { GoalPortfolioResponseDTO } from "web_myplann/Infrastructure/Api/Api";

type AllocationLimits = {
	currentForThis: number;
	usedOnOther: number;
	maxForThis: number;
};

export const useAllocationLimits = (
	portfolio: GoalPortfolioResponseDTO | null,
): AllocationLimits => {
	const { data } = useGoalDetailPortfoliosQuery();

	const currentForThis = portfolio?.usagePercent ?? 0;
	const items = data?.data ?? [];
	const globalUsed =
		items.find((p) => p.id === portfolio?.portfolioId)?.usagePercent ??
		currentForThis;
	const usedOnOther = Math.max(0, globalUsed - currentForThis);
	const maxForThis = Math.max(ALLOCATION_MIN, ALLOCATION_MAX - usedOnOther);

	return { currentForThis, usedOnOther, maxForThis };
};
